import cx from 'classnames';
import PropTypes from 'prop-types';

import { BrandTerms } from '../../components/BrandTerms';
import { PlagiarismChecker } from '../../components/PlagiarismChecker';
import { ReadabilityScore } from '../../components/ReadabilityScore';
import { SEOScore } from '../../components/SEOScore';
import { SEOTracker } from '../../components/SEOTracker';
import { DetectedBrandTermsProvider, preparePropTypesFromChildComponent } from '../../lib';

import { useStyles } from './useStyles';

export const BlogInsightsPanel = ({
  className,
  classes,
  brandTermsProps,
  readabilityScoreProps,
  seoTrackerProps,
  plagiarismCheckerProps,
  seoScoreProps,
}) => {
  const styles = useStyles({ classes });

  return (
    <DetectedBrandTermsProvider
      onApplyBrandTerm={brandTermsProps?.onApplyBrandTerm}
      appliedDetectedTermIds={brandTermsProps?.appliedDetectedTermIds}
    >
      <div
        className={cx(styles.root, className)}
        data-testid="BlogInsightsPanel"
        data-component="BlogInsightsPanel"
      >
        <div className={styles.detailsBody}>
          {seoScoreProps && !seoScoreProps?.empty && (
            <div>
              <SEOScore {...seoScoreProps} />
            </div>
          )}
          {(seoScoreProps === null || seoScoreProps.empty) && readabilityScoreProps && (
            <ReadabilityScore {...readabilityScoreProps} />
          )}
          {plagiarismCheckerProps && <PlagiarismChecker {...plagiarismCheckerProps} />}
          {(seoScoreProps === null || seoScoreProps.empty) && seoTrackerProps && (
            <SEOTracker {...seoTrackerProps} />
          )}
          {brandTermsProps && (
            <BrandTerms
              classes={{ root: styles.groupContainer, boxGroupTitle: styles.boxGroupTitle }}
              {...brandTermsProps}
            />
          )}
        </div>
      </div>
    </DetectedBrandTermsProvider>
  );
};

BlogInsightsPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape(),
  brandTermsProps: preparePropTypesFromChildComponent(BrandTerms.propTypes),
  readabilityScoreProps: preparePropTypesFromChildComponent(ReadabilityScore.propTypes),
  seoTrackerProps: preparePropTypesFromChildComponent(SEOTracker.propTypes),
  plagiarismCheckerProps: preparePropTypesFromChildComponent(PlagiarismChecker.propTypes),
  seoScoreProps: PropTypes.shape({ empty: PropTypes.bool }),
};

BlogInsightsPanel.defaultProps = {
  className: null,
  classes: null,
  brandTermsProps: null,
  readabilityScoreProps: null,
  seoTrackerProps: null,
  plagiarismCheckerProps: null,
  seoScoreProps: null,
};
